module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.detailsTask,
      "withBody": false,
      "withFooter": false,
      "to": {
        name: 'tokenEdit',
        params: {
          identifier: _vm.token._id.$oid
        }
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('span', {
    staticClass: "badge",
    class: {
      success: _vm.token.status,
      error: !_vm.token.status
    }
  }, [_vm._v(_vm._s(_vm.$t(("token.status." + (_vm.token.status) + ".label"))))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d18d9882","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/api/TokenCard.vue
// module id = 3442
// module chunks = 0